/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from "react";



const DropdownPossibleNextStep: FC = (): JSX.Element => {
  return (
    <li className="nav-item dropdown">
      <a role="button" className="nav-link dropdown-toggle" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
        Possible "Next Steps"
      </a>

      <ul className="colors-dropdown dropdown-menu dropdown-menu-end px-4 py-3">
        <p className="fw-lighter fs-6"  aria-expanded="false">
          On the case screen, you can see a new column labeled "Next Steps" ... These new options allow you to update 
          your cases without the need to contact the Solution Center. The actions available are as follows:
        </p>
        <li>
          <hr className="dropdown-divider" />
        </li>

        <li>
          <div className="row">
            <div className="col-sm-4">
              <span className="btn background-color-5 my-1 text-white">
                <i className="fas fa-clipboard-list"></i> Precert
              </span>
            </div>
            <div className="col-sm-8 p-2">
              Clicking "Precert" allows you to upload clinicals and enter information for the precert as well as submit it to the 
              plan or request it be completed on your behalf.
            </div>
          </div>
        </li>

        <li>
          <hr className="dropdown-divider" />
        </li>

        <li>
          <div className="row">
            <div className="col-sm-4 ml-3 pl-3">
              <span className="btn background-color-3 my-1 text-white">
                <i className="far fa-hospital"></i> Buy & Bill
              </span>
            </div>
            <div className="col-sm-8 p-2">
              Clicking "Buy & Bill" Changes the case status to "Pulled from Stock"
            </div>
          </div>
        </li>

        <li>
          <hr className="dropdown-divider" />
        </li>

        <li>
          <div className="row">
            <div className="col-sm-4">
              <span className="btn background-color-3 my-1 text-white">
                <i className="fas fa-prescription"></i> Xfer to SP
              </span>
            </div>
            <div className="col-sm-8 p-2">
              Clicking "Xfer to SP" Transfers the prescription through the Specialty pharmacy network.
            </div>
          </div>
        </li>

        <li>
          <hr className="dropdown-divider" />
        </li>

        <li>
          <div className="row">
            <div className="col-sm-4">
              <span className="btn background-color-3 my-1 text-white">
                <i className="bi bi-person-fill"></i> Patient Direct
              </span>
            </div>
            <div className="col-sm-8 p-2">
              The Patient Direct Program (PDP) offers EUFLEXXA to uninsured or underinsured patients for $425. Simply click PDP to 
              send a EUFLEXXA prescription to CareMed Pharmacy for fulfillment. CareMed will contact the patient for payment and 
              ship EUFLEXXA directly to your office.
            </div>
          </div>
        </li>

      </ul>
    </li>
  );
};

export default DropdownPossibleNextStep;
